/**
 * 自动化任务翻译 - 中文
 * Automation - Chinese
 */
export const automationZh = {
  // 基础
  title: '自动化任务',
  subtitle: '管理和监控所有自动化任务',
  
  // 统计
  totalTasks: '总任务数',
  totalExecutions: '总执行次数',
  recentFailures: '近24h失败',
  successRate: '成功率',
  active: '运行中',
  
  // 状态
  statusActive: '运行中',
  statusPaused: '已暂停',
  statusDisabled: '已禁用',
  
  // 执行状态
  execSuccess: '成功',
  execFailed: '失败',
  execRunning: '运行中',
  execPending: '等待中',
  execTimeout: '超时',
  execCancelled: '已取消',
  
  // 任务类型
  typeLdapSync: 'Entra ID 同步',
  typeDataCleanup: '数据清理',
  typeReportGeneration: '报表生成',
  typeNotification: '通知推送',
  typeBackup: '数据备份',
  typeCustom: '自定义任务',
  
  // 筛选
  allTypes: '所有类型',
  allStatuses: '所有状态',
  
  // 表格列
  taskName: '任务名称',
  type: '类型',
  status: '状态',
  lastRun: '最后运行',
  lastResult: '运行结果',
  statistics: '统计',
  total: '总计',
  success: '成功',
  failed: '失败',
  
  // 操作
  execute: '执行',
  pause: '暂停',
  resume: '恢复',
  viewLogs: '查看日志',
  
  // 消息
  noTasks: '暂无任务',
  taskNotFound: '任务不存在',
  confirmExecute: '确定要立即执行此任务吗？',
  executeStarted: '任务已开始执行',
  executeFailed: '执行失败',
  
  // 详情页
  taskInfo: '任务信息',
  executionHistory: '执行历史',
  executionLogs: '执行日志',
  description: '任务描述',
  scheduleType: '调度类型',
  scheduleConfig: '调度配置',
  timeout: '超时时间',
  retryCount: '重试次数',
  creator: '创建者',
  taskConfig: '任务配置',
  startTime: '开始时间',
  duration: '执行时长',
  triggerType: '触发方式',
  actions: '操作',
  noExecutions: '暂无执行记录',
  executionId: '执行ID',
  errorMessage: '错误信息',
  executionResult: '执行结果',
  selectExecution: '请从执行历史中选择一条记录查看日志',
  back: '返回',
};

export type AutomationTranslations = typeof automationZh;

